import {
  RdDocumentationStatus,
  rdDocumentationStatusLabel,
  rdProjectCategoryLabel,
  SelectedRdProjectCategory,
} from '@common/neo.tax';

import { ColumnDefinition, FilterField, FilterSortDataType, RdProjectFilter } from '@neo.tax/shared';

export const filterableRdProjectColumns = [
  { name: 'name', label: 'Name', dataType: FilterSortDataType.TEXT },
  { name: 'productName', label: 'Product', dataType: FilterSortDataType.TEXT },
  {
    name: 'selectedCategory',
    label: 'R&D Status',
    dataType: FilterSortDataType.ENUM,
    enum: Object.entries(rdProjectCategoryLabel).map(([value, label]) => ({
      value: value as SelectedRdProjectCategory,
      label: label as string,
    })),
  },
  {
    name: 'aiGuidance',
    label: 'AI Guidance',
    dataType: FilterSortDataType.ENUM,
    enum: [
      { value: 'R&D Credit Eligible', label: 'R&D Credit Eligible' },
      { value: 'Needs Review', label: 'Needs Review' },
      { value: 'Not Qualified', label: 'Not Qualified' },
    ],
  },
  {
    name: 'rdDocumentationStatus',
    label: 'R&D Details',
    dataType: FilterSortDataType.ENUM,
    enum: Object.entries(rdDocumentationStatusLabel).map(([value, label]) => ({
      value: value as RdDocumentationStatus,
      label: label as string,
    })),
  },
  { name: 'workstreamNamesSearch', label: 'Teams', dataType: FilterSortDataType.TEXT },
  {
    name: 'ticketCount',
    label: 'Ticket Count',
    dataType: FilterSortDataType.NUMBER,
  },
  { name: 'projectOwnerName', label: 'Project Owner', dataType: FilterSortDataType.TEXT },
] as const satisfies readonly ColumnDefinition<FilterField<RdProjectFilter>>[];

export const sortableRdProjectColumns = [...filterableRdProjectColumns] as const satisfies readonly ColumnDefinition<
  FilterField<RdProjectFilter>
>[];
